import http from 'shared/utils/http';

export const getContractLinks = () => {
  return http.get('/netwila-core/contract/contract-link');
};

export const addContractLinks = (data) => {
  return http.post('/netwila-core/contract/contract-link', data);
};
